
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CompletionList,
} from '../models';
import {
    CompletionListFromJSON,
    CompletionListToJSON,
} from '../models';

/**
 * 
 */
export class CompletionApi extends runtime.BaseAPI {

    /**
     * Returns the completion list for current user 
          */
    async getCompletionListRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CompletionList>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CompletionList>({
            path: `/profile/api/completion-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CompletionListFromJSON(response._data); }
        return response;
    }

    /**
     * Returns the completion list for current user 
          */
    async getCompletionList(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CompletionList> {
        const response = await this.getCompletionListRaw(initOverrides);
        return response._data;
    }

}
